import type { SelectProps } from "@mui/material";
import { Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import variables from "../../../assets/styles/_variables.module.scss";
const SErrorSelect = styled((props: SelectProps) => <Select {...props} />)(({ theme }) => ({
    "&.MuiOutlinedInput-root": {
        borderRadius: 0,
        padding: 0,
        fontSize: "0.875rem",
        "& fieldset": {
            border: "none",
        },
        "&.Mui-focused": {
            backgroundColor: variables["input-backgr"],
        },
        "&.Mui-focused fieldset": {
            border: "2px solid black",
        },
    },
}));

function StyledErrorSelect(props: Partial<SelectProps>) {
    return <SErrorSelect {...props} />;
}

export default StyledErrorSelect;
